module.exports = __webpack_public_path__ + "img/20191231154656360截图20191231113629781.4deda0c5.jpg";